
import {toast} from 'react-toastify'
function InfoMesages(msg){
    toast.success(msg,{
        position: toast.POSITION.TOP_CENTER,
        autoClose:true,
        progressStyle:{"transform-origin": "right"} });

}
export default InfoMesages;